import "css!js/file_viewer/preview_content/preview_content.module.out.css";
export const previewContent = "_previewContent_1t0x7_1";
export const previewContentWrapper = "_previewContentWrapper_1t0x7_11";
export const hidden = "_hidden_1t0x7_18";
const classes = { "previewContent": "_previewContent_1t0x7_1", "previewContentWrapper": "_previewContentWrapper_1t0x7_11", "hidden": "_hidden_1t0x7_18" };
export default classes;
//# sourceMappingURL=preview_content.module.css.preenvesnextjs.map
